:host {
  /* stylelint-disable-next-line pine-design-system/no-hardcoded-colors */
  --box-shadow-fixed: 3px 3px 6px -2px rgba(0, 0, 0, 0.2);

  color: var(--pine-color-text);
  display: table-cell;
  font-family: var(--pine-font-family-body);
  font-size: var(--pine-font-size);
  font-weight: var(--pine-font-weight-regular);
  inset-inline-start: var(--pine-dimension-none);
  letter-spacing: var(--pine-letter-spacing);
  line-height: var(--pine-line-height-body);
  padding: var(--pine-dimension-sm);
  vertical-align: middle;
}

:host(.is-compact) {
  padding-block: var(--pine-dimension-2xs)
}

:host(.is-fixed) {
  background: var(--pine-color-background-container);
  inset-inline-start: 0;
  position: sticky;
  z-index: var(--pine-z-index-raised);
}

// Flip shadow toward scrollable content when fixed column is on the inline-end edge.
:host-context([dir='rtl']) {
  /* stylelint-disable-next-line pine-design-system/no-hardcoded-colors */
  --box-shadow-fixed: -3px 3px 6px -2px rgba(0, 0, 0, 0.2);
}

// box shadow when table has scrolled and cell is fixed
:host(.has-scrolled.is-fixed) {
  box-shadow: var(--box-shadow-fixed);
}

:host(.is-truncated) {
  max-width: var(--pds-table-cell-truncate-max-width, 100px);
  overflow: hidden;
  text-overflow: ellipsis;
  white-space: nowrap;
}

:host(.has-checkbox) {
  vertical-align: middle;
  width: 16px;
}

// Text Alignment
:host(.pds-table-cell--align-start) {
  text-align: start;
}

:host(.pds-table-cell--align-center) {
  text-align: center;
}

:host(.pds-table-cell--align-end) {
  text-align: end;
}

:host(.pds-table-cell--align-justify) {
  text-align: justify;
}
